import React, {useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';

import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faPause} from '@fortawesome/free-solid-svg-icons'

import {SET_DISPLAY_TIME, SET_PLAYBACK_STATE } from '../state/uiActions'
import {SET_DISPLAY_TIME_FILTERING} from '../state/viewportItemActions'


import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Form } from 'react-bootstrap';

const timeMin = (new Date('2023-10-14T07:20:00')).getTime()
const timeMax = (new Date('2023-10-14T18:00:00')).getTime() 

// how often to update the map (in msec): 
// 24 FPS (motion pictures): 41.667 msec
const mapUpdateTimeGapMsec = 50 // 300 100 1000
// how much we should wait before repeating the playback:
const playbackRepeatDelayMSec = 10000

export default function DisplayTimeOverlay(props) {
  const dispatch = useDispatch(); 

  //const timeFrom = useSelector((state) => state.ui.displayTime.timeFrom) ;
  const timeTo = useSelector((state) => state.ui.displayTime.timeTo) ;
  const ts = new Date(timeTo)
  const distSumKm = useSelector((state) => state.viewport.distSumKm) ;
  const playbackState = useSelector((state) => state.ui.playbackState) ;

// how long the playback should last (in minutes):
  const playbackLengthMinutes = useRef(1)   // 4.8 ;

  // when the last update started - to compute how much we progressed on the trail:
  const lastUpdateBeginTime = useRef(null)
  // the percentage of the playback we are currently at:
  const playbackPercentRef = useRef(0.0)
  // this is the actual time we are currently at in the playback:
  const trailTimeRef = useRef(timeMin)
  // keep timeouts to be able to cancel them:
  const timeoutRef = useRef(null)

  const handleClick = () => {
    var pstate = 'playing'
    if (playbackState=='playing') pstate = 'paused'
    dispatch({ type: SET_PLAYBACK_STATE, playbackState: pstate })
    if (pstate=='playing') {
      lastUpdateBeginTime.current = new Date().getTime()
      timerUpdate()
    }
  }  

  const timerUpdate = async () => {
    if (playbackState=='playing' ) {
      // trailTimeRef.current < timeMax 
      const playbackTimePassed = (new Date()).getTime() - lastUpdateBeginTime.current 
      lastUpdateBeginTime.current = new Date().getTime()

      // TODO: simplify expression
      trailTimeRef.current += ( (timeMax -timeMin) / 
      ( playbackLengthMinutes.current * 60 * 1000 / mapUpdateTimeGapMsec ) ) * (playbackTimePassed / mapUpdateTimeGapMsec)
      
      playbackPercentRef.current = (trailTimeRef.current-timeMin) / (timeMax-timeMin) *100
      
      clearTimeout( timeoutRef.current )

      timeoutRef.current = setTimeout(() => {
        // start over when finished: 
        if (trailTimeRef.current >= timeMax)  {
          setTimeout(() => {
            trailTimeRef.current = timeMin 
            // TODO: merge SET_DISPLAY_TIME_* actions
            dispatch( {type: SET_DISPLAY_TIME, 
              displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
            dispatch( {type: SET_DISPLAY_TIME_FILTERING, 
              displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} )               
            if (timeoutRef.current) clearTimeout( timeoutRef.current)
            timeoutRef.current = null
            timerUpdate()
          }, playbackRepeatDelayMSec)
        }
        else {
          dispatch( {type: SET_DISPLAY_TIME, 
            displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
          dispatch( {type: SET_DISPLAY_TIME_FILTERING, 
            displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
          timeoutRef.current = null
          timerUpdate()
        }
        }, mapUpdateTimeGapMsec 
      )
    }
  }

  useEffect(() => {
    if (playbackState=='playing') timerUpdate()
    // TODO: no use waiting this way, tha map will not be positioned
    else if (playbackState == 'init') {
      timeoutRef.current = setTimeout(() => {
        lastUpdateBeginTime.current = new Date().getTime()
        dispatch({ type: SET_PLAYBACK_STATE, playbackState: 'playing' })
      }, 3000 )
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }

  }, [timeTo, playbackState])

  const handleSliderChange = (newValue) => {
    
    trailTimeRef.current = (timeMax - timeMin) * (newValue / 100) + timeMin
    playbackPercentRef.current = newValue 
    clearTimeout( timeoutRef.current )
    timeoutRef.current = null

    dispatch( {type: SET_DISPLAY_TIME, 
      displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
    dispatch( {type: SET_DISPLAY_TIME_FILTERING, 
      displayTime: {timeFrom: timeMin, timeTo: trailTimeRef.current}} ) 
    timerUpdate()
  };

  const handleSelectChange = (e) => {
    playbackLengthMinutes.current = e.target.value    
  };    

  // HACK: 
  //if (isNaN(dkm) || (dkm < 19) ) dkm = 0
  var distString = Math.round(distSumKm).toLocaleString( "HU-hu", { minimumFractionDigits: 0 } ) ;

  var icon = faPlay ;
  if (playbackState=='playing' || playbackState=='init') icon = faPause 
  return (
    <>
    <div className="btn btn-secondary playerOverlay monospace">
      <div className="playerOverlayTop">
        <FontAwesomeIcon icon={icon} size="xl" onClick={() => handleClick()}/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <Form.Select size="sm" onChange={handleSelectChange}>
          <option value="1" selected>1 perc</option>
          <option value="2">2 perc</option>
          <option value="3">3 perc</option>
          <option value="5">5 perc</option>
          <option value="10">10 perc</option>
        </Form.Select>
      </div>

      <Slider 
        value={playbackPercentRef.current}
        min={0}
        max={100}
        step={1}
        onChange={handleSliderChange}
      />
      <br/>
      <div onClick={() => handleClick()}>
        <b>
        {//'D ' + String(ts.getDate()) + " - " +
               String(ts.getHours()).padStart(2, '0') + 
        ":" +  String(ts.getMinutes()).padStart(2, '0') + 
        ":" +  String(ts.getSeconds()).padStart(2, '0') }
        &nbsp;&nbsp; </b>
        {distString}  km<br/>
      </div>
    </div>
    </>
    //)
    //, document.getElementById('timerOverlay')
  ); 

}